'use client';

import { useSearchParams } from 'next/navigation';
import { setCookie } from 'cookies-next';

import useMinifyChecker from '@/hooks/useMinifyChecker';

import LeftSidebar from '../Login/sections/LeftSidebar';
import SignupForm from './sections/SignupForm';

const SignupPage = ({ tenant, secondary_user_id }: any) => {
  if (
    typeof window !== 'undefined' &&
    tenant &&
    Object.keys(tenant)?.length > 0 &&
    tenant !== undefined
  ) {
    window.sessionStorage.setItem('tenant', JSON.stringify(tenant));
    setCookie('tenant', JSON.stringify(tenant));
  }

  const searchParams = useSearchParams();
  const minifyParams = searchParams.get('minify') as string | undefined;
  const postParent = searchParams.get('postParent') as string | undefined;
  // Standardize on redirect_uri (OAuth/OIDC standard) but support redirecturl for backward compatibility
  const redirectURLParams = (searchParams.get('redirect_uri') || searchParams.get('redirecturl')) as
    | string
    | undefined;
  const clientId = searchParams.get('clientId') as string | undefined;
  const additionalData = searchParams.get('additionalData') as
    | string
    | undefined;
  const app_id = searchParams.get('app_id') as string | undefined;

  const additionalDataObj = additionalData ? JSON.parse(additionalData) : {};

  if (app_id && typeof window !== 'undefined') {
    window.sessionStorage.setItem('app_id', app_id);
    setCookie('app_id', app_id);
  } else if (typeof window !== 'undefined') {
    window.sessionStorage.removeItem('app_id');
    setCookie('app_id', '');
  }

  if (
    typeof window !== 'undefined' &&
    redirectURLParams &&
    redirectURLParams !== undefined
  ) {
    // Store as redirect_uri (standard) but also keep redirecturl for backward compatibility
    window.sessionStorage.setItem('redirect_uri', redirectURLParams);
    window.sessionStorage.setItem('redirecturl', redirectURLParams);
  }

  if (typeof window !== 'undefined' && postParent && postParent !== undefined) {
    window.sessionStorage.setItem('postParent', 'true');
  }

  // setting the tenantId in the session storage for the linkedin login.
  if (tenant?._id !== undefined && typeof window !== 'undefined') {
    window.sessionStorage.setItem('tenantId', tenant?._id);
    if (clientId !== undefined && clientId !== '' && clientId !== null) {
      window.sessionStorage.setItem('clientId', clientId);
    }
  }

  const { setMinifyInSessionStorage } = useMinifyChecker();
  setMinifyInSessionStorage(minifyParams);

  const { minify } = useMinifyChecker();

  return (
    <div className="h-screen bg-zinc-100 p-[24px]">
      <div
        className={`rounded-3xl bg-white ${minify ? 'grid-cols-1' : 'grid-cols-2'} grid`}
      >
        <SignupForm
          tenant={tenant}
          secondary_user_id={secondary_user_id}
          additionalDataObj={additionalDataObj}
        />
        {!minify && <LeftSidebar tenant={tenant} />}
      </div>
    </div>
  );
};
export default SignupPage;
